import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { getDeliveryDateData } from "../../lib/getDeliveryDateData";
import getLocalData from "../../lib/getLocalData";
import setLocalDeliveryData from "../../lib/setLocalDeliveryData";
import customUrlSearchParams from "../../lib/customUrlSearchParams";
import mixpanel from "../../lib/mixPanel";

class DeliverIn extends Component {
  constructor(props) {
    super(props);
    const { preOrderEnd, preOrderStart } = props;
    const searchParams = new customUrlSearchParams(props.location.search);
    const dateData = getDeliveryDateData(preOrderStart, preOrderEnd, true);
    const preOrder = searchParams.get("time");
    const postalCode = searchParams.get("postcode");
    let selectedDate;
    if (preOrder) {
      selectedDate = preOrder === "now" ? "ASAP" : preOrder;
    } else {
      selectedDate = dateData[0];
    }
    this.state = {
      dateData,
      selectedDate,
      preOrder,
      postalCode,
      selectPreOrder: preOrder && preOrder !== "now"
    };
  }
  setLocalDataCallback = (postalCode, preOrder, selectedDate, delivery) => {
    const curretLocation = window.location.href;

    mixpanel.track("Change Delivery Details", {
      _postCode: postalCode,
      _when: preOrder || "Asap",
      _how: (delivery && "Delivery") || "Collection",
      _distance: 0
    });

    let newHref;
    if (preOrder) {
      newHref = curretLocation.replace(
        `&time=${preOrder}`,
        `&time=${(selectedDate === "ASAP" && "now") || selectedDate}`
      );
    } else {
      newHref =
        (postalCode && `${curretLocation}&time=${selectedDate}`) ||
        (curretLocation.endsWith("/") &&
          `${curretLocation}?time=${selectedDate}`) ||
        `${curretLocation}/?time=${selectedDate}`;
    }
    if (newHref) {
      window.location.replace(newHref);
    }
  };
  select = selectedDate => {
    if (selectedDate) {
      const { preOrder, postalCode } = this.state;
      let deliveryDetails;
      let localData = getLocalData("deliveryDetails");
      if (localData) {
        deliveryDetails = localData;
      } else {
        deliveryDetails = {};
      }
      deliveryDetails.preOrder =
        (selectedDate === "ASAP" && "") || selectedDate;
      const jsonData = JSON.stringify(deliveryDetails);
      setLocalDeliveryData(jsonData, () =>
        this.setLocalDataCallback(
          postalCode,
          preOrder,
          selectedDate,
          deliveryDetails.delivery
        )
      );
    }
  };
  handleClickPreOrder = () => {
    this.setState({
      selectPreOrder: true
    });
  };
  renderListItems = () => {
    const { dateData, selectPreOrder } = this.state;
    return (
      (selectPreOrder &&
        ((dateData.length &&
          dateData.map((listItem, index) => {
            return (
              <div
                key={index}
                className="p-15"
                onClick={() => this.select(listItem)}
              >
                <span>{listItem}</span>
              </div>
            );
          })) || <noscript />)) || (
        <>
          <div className="p-15" onClick={() => this.select("ASAP")}>
            ASAP
          </div>
          <div
            className="p-15"
            id="pre-order-div"
            onClick={this.handleClickPreOrder}
          >
            Pre-order
          </div>
        </>
      )
    );
  };
  show = () => {
    var el = document.getElementById("pre-order-div");
    var elCont = document.getElementById("dropdown-container");
    this.setState({ listVisible: true, isOpen: true }, () => {
      document.addEventListener("click", this.hide);
      document.preOrderDiv = el;
      document.dropdownCont = elCont;
    });
  };
  hide = event => {
    if (
      document.preOrderDiv === event.target ||
      document.dropdownCont === event.target
    ) {
      return;
    } else {
      this.setState({
        listVisible: false,
        isOpen: false
      });
    }

    document.removeEventListener("click", this.hide);
  };
  render() {
    const { listVisible, selectedDate } = this.state;
    return (
      <div
        className={
          "dropdown-container custom-dropdown-container" +
          (listVisible ? " show" : "")
        }
      >
        <div
          className={"dropdown-display" + (listVisible ? " clicked" : "")}
          onClick={this.show}
        >
          <span id="dropdown-container">{selectedDate}</span>
          <i className="icon icon-arrow-left open" />
        </div>
        <div className="dropdown-list custom-dropdown-list">
          <div>{this.renderListItems()}</div>
        </div>
      </div>
    );
  }
}

export default withRouter(DeliverIn);
